import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueGtag from 'vue-gtag';

// import components
import App from './App.vue';
import HomeScreen from '@/components/homeComponents/HomeScreen.vue';
import PrivacyView from '@/components/homeComponents/PrivacyView.vue'
import TermsView from '@/components/homeComponents/TermsView.vue';
import DemoSetupScreen from '@/components/demoComponents/DemoSetupScreen.vue';
import GameSetupScreen from '@/components/gameComponents/GameSetupScreen.vue';
import GameScreen from '@/components/gameComponents/GameScreen.vue';
import DemoScreen from '@/components/demoComponents/DemoScreen.vue';
import OnboardingScreen from '@/components/onboardingComponents/OnboardingScreen.vue';
import PricingScreen from '@/components/pricingAndTeamComponents/PricingScreen.vue';
import PromptsScreen from '@/components/promptViewComponents/PromptsScreen.vue';
import PromptLibraryView from '@/components/promptViewComponents/PromptLibraryView.vue';
import PromptPacksView from '@/components/promptViewComponents/PromptPacksView.vue';
import TeamHomeView from '@/components/teamHomeComponents/TeamHomeView.vue';
import TeamAccountView from '@/components/pricingAndTeamComponents/TeamAccountView.vue';
import ProfileView from '@/components/profileComponents/ProfileView.vue';
import JoinTeamView from '@/components/pricingAndTeamComponents/JoinTeamView.vue';
import CreateSubscriptionCallbackScreen from '@/components/pricingAndTeamComponents/CreateSubscriptionCallbackScreen.vue';
import Page404 from '@/components/errorPageComponents/Page404.vue';

// Auth0-based auth guard
import { authGuard } from '@/auth/authGuard';

// Lazysizes for lazy loading images
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

library.add(far.faCommentDots);
library.add(fas.faChevronDown);
library.add(fas.faMicrophone);
library.add(fas.faMicrophoneSlash);
library.add(fas.faVideo);
library.add(fas.faVideoSlash);
library.add(fas.faSearch);
library.add(fas.faCopy);
library.add(fas.faDoorOpen);
library.add(far.faCircle);
library.add(fas.faCircle);
library.add(fas.faCheckCircle);
library.add(fas.faCrown);
library.add(fas.faRedoAlt);
library.add(fas.faLightbulb);
library.add(fas.faVolumeUp);
library.add(fas.faVolumeDown);
library.add(fas.faVolumeOff);
library.add(fas.faVolumeMute);
library.add(fas.faEllipsisV);
library.add(fas.faEdit);

Vue.component('font-awesome-icon', FontAwesomeIcon);

// Import the Auth0 configuration
import { domain, clientId, audience } from "@/auth/authConfig";

// Import the plugin here
import { Auth0Plugin } from "./auth";

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

// Set up routes and route guards
const routes = [
  { 
    path: '/',
    name: 'landing',
    component: HomeScreen,
    children: [{
      path: 'pricing',
      name: 'pricing',
      // component: PricingView,
      // beforeEnter: authGuard
      component: PricingScreen,
      beforeEnter: authGuard
    }, {
      path: 'prompts',
      name: 'prompts',
      component: PromptsScreen,
      beforeEnter: authGuard,
      children: [{
        path: 'library',
        name: 'promptlibrary',
        component: PromptLibraryView,
        beforeEnter: authGuard
      }, {
        path: 'packs',
        name: 'promptpacks',
        component: PromptPacksView,
        beforeEnter: authGuard
      }]
    }, {
      path: 'privacy',
      name: 'privacy',
      component: PrivacyView
    }, {
      path: 'terms',
      name: 'terms',
      component: TermsView
    }, {
      path: 'team',
      name: 'team',
      component: TeamAccountView,
      beforeEnter: authGuard
    }, {
      path: 'home',
      name: 'home',
      component: TeamHomeView,
      beforeEnter: authGuard
    }, {
      path: 'profile',
      name: 'profile',
      component: ProfileView,
      beforeEnter: authGuard
    }, {
      path: 'jointeam',
      name: 'jointeam',
      component: JoinTeamView,
      beforeEnter: authGuard
    }]
  }, {
    path: '/onboarding',
    name: 'onboarding',
    component: OnboardingScreen,
    props: true,
    beforeEnter: authGuard
  }, {
    path: '/gamesetup',
    name: 'gamesetup',
    component: GameSetupScreen,
    props: true,
    beforeEnter: authGuard
  }, {
    path: '/weavr',
    name: 'weavr',
    component: GameScreen,
    props: true,
    beforeEnter: authGuard
  }, {
    path: '/demosetup',
    name: 'demosetup',
    component: DemoSetupScreen,
    props: true,
    // beforeEnter: authGuard
  }, {
    path: '/demo',
    name: 'demoweavr',
    component: DemoScreen,
    props: true,
  }, {
    path: '/createsubscription',
    name: 'createsubscriptioncallback',
    component: CreateSubscriptionCallbackScreen,
    beforeEnter: authGuard
  }, {
    path: '*',
    name: 'page404',
    component: Page404
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

// Vue Router
Vue.use(VueRouter);

// Axios
Vue.use(VueAxios, axios);

// Google Analytics 4 with vue-gtag
Vue.use(VueGtag, {
  config: {
    id: 'G-GY3KEQH8FH',
    params: {
      send_page_view: false
    }
  }
}, router);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
